module.exports = __webpack_public_path__ + "static/media/client7.a982c10e.svg";